import { useEffect, useState } from "react";

import * as S from "./styles";

import { useTheme } from "styled-components";

const GetIcon = ({ name, color, size = "md", type = "regular", onClick }) => {
  const theme = useTheme();
  const [icon, setIcon] = useState(<></>);

  if (!color) {
    color = theme.colors.primary.vividCerulean;
  }

  useEffect(() => {
    getIconFile(name, color, type);
  }, [name, color, type]);

  const getIconFile = async (iconFileName, iconColor, iconType) => {
    const module = await import(`./Components/${iconFileName}`);

    setIcon(module.default({ color: iconColor, type: iconType }));
  };

  return (
    <S.Wrapper size={size} onClick={onClick}>
      {icon}
    </S.Wrapper>
  );
};

export default GetIcon;
